import styled from 'styled-components'
import Icon from '@/components/common/Icon'
import useHTMLText from '@/hooks/useHTMLText'
import classNames from 'classnames'
import { AdsChip } from '@/components/Ads/SearchBar/SearchBarStyled'

const Chip = styled(AdsChip)`
  position: relative;
  display: inline-flex;
  align-items: center;
  padding-right: 4px;
  padding-left: 32px;
  transition: border-color 0.26s ease-in-out;
  border: 1px solid var(--purple);
  border-radius: 16px;
  height: 32px;
  cursor: pointer;

  &.title {
    border-color: var(--yellow);

    .type {
      background-color: var(--yellow);

      .icon-decor {
        background-color: var(--secondary);
      }
    }
  }

  &.link {
    border-color: var(--success-new);

    .type {
      background-color: var(--success-new);
    }
  }

  &:hover {
    border-color: var(--stroke);
  }
`

const ChipType = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translate(-1px, -1px);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  transition: background-color 0.26s ease-in-out;
  background-color: var(--purple);
`

const ChipText = styled.div`
  padding: 3px 6px;
  font-size: 14px;
  line-height: 1.2em;
  font-weight: 500;
  color: var(--secondary);
`

const ChipDelete = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: rgba(var(--natural-black-rgb), 0.25);
  border-radius: 50%;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.26s ease-in-out;

  .icon-delete {
    width: 18px;
    height: 18px;
    background-color: var(--white);
  }

  &:hover {
    opacity: 0.8;
  }
`

const SearchBarChip = ({
  chip,
  isDeleted,
  onSelected = () => {},
  text,
  onDelete,
}) => {
  const correctType = chip.type ?? 'text'
  const chipClasses = classNames({
    [correctType]: true,
  })
  const htmlText = useHTMLText(chip[text])

  const onChipClick = (e, data) => {
    e.stopPropagation()
    onSelected(data)
  }

  if (!chip[text]) return

  return (
    <Chip onClick={(e) => onChipClick(e, chip)} className={chipClasses}>
      <ChipType className="type">
        <Icon
          className="icon-decor"
          icon={`filter-search-${correctType}`}
          size={16}
          color="white"
        />
      </ChipType>
      <ChipText dangerouslySetInnerHTML={{ __html: htmlText }}></ChipText>
      {isDeleted && (
        <ChipDelete
          onClick={(e) => {
            e.stopPropagation()
            onDelete(chip)
          }}
        >
          <Icon className="icon-delete" icon="x-close" />
        </ChipDelete>
      )}
    </Chip>
  )
}

export default SearchBarChip
